import styled, { css } from "styled-components";

export const CheckboxGridRow = styled.div`
  // display: grid;
  // grid-template-columns: ${(props) => props.column};
  // overflow-y: auto;
  // height: 100%;
  column-count: 3;
  margin: 10px;
`;

export const DepartmentCountText = styled.span`
  font-size: 14px;
  color: #767676;
  font-style: italic;
  float: right;
`;

export const ComponentContainer = styled.div`
  height: 300px;
  border: 1px solid;
  border-color: ${(props) => (props.error ? "red" : "#1BACE4")};
  padding: 10px;
  overflow: auto;
`;

export const ErrorLabel = styled.span`
  font-weight: bold;
  color: red;
  font-style: italic;
  float: left;
`;

export const ComponentContainerEmpty = styled.div`
  height: 300px;
  border: 1px solid;
  border-color: ${(props) => (props.error ? "red" : "#1BACE4")};
  text-align: center;
  line-height: 300px;
`;
